module.exports = __webpack_public_path__ + "img/alurbadgemobile.36811bf1.svg";